import axios from 'axios';

export const state = {
  bPendingTrades: [],
  loading: false,
};

export const mutations = {
  setBPendingTrades(context, bPendingTrades) {
    context.bPendingTrades = bPendingTrades;
    context.loading = false;
  },

  setLoading(context, value) {
    context.loading = value;
  },
};

export const actions = {
  async getBPendingTrades({ commit, rootState }) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      commit('setLoading', true);

      const bPendingTrades = await axios.get(`${window.BASE_API.TRADING_PLATFORM}/orderbook/status/trades/transferred`, options)
        .then(response => response.data);

      commit('setBPendingTrades', bPendingTrades);
      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },

  async approveBPendingTrades({ commit, rootState, dispatch }, data) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      commit('setLoading', true);

      await axios.patch(`${window.BASE_API.TRADING_PLATFORM}/orderbook/status/trades/transferred`, data, options)
        .then(response => response.data);

      dispatch('getBPendingTrades');
      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },

  async cancelBPendingTrades({ commit, rootState }, data) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      commit('setLoading', true);

      const bPendingTrades = await axios.delete(`${window.BASE_API.TRADING_PLATFORM}/orderbook/status/trades/transferred`, { data }, options)
        .then(response => response.data);

      commit('setBPendingTrades', bPendingTrades);
      commit('setLoading', false);
    } catch (err) {
      console.error(err);
      commit('setLoading', false);
    }
  },
};

const bPendingTradesStore = {
  state,
  mutations,
  actions,
};

export default bPendingTradesStore;



// WEBPACK FOOTER //
// ./src/store/trades/blockchainPendingTradesStore.js